import { getRouteByPath } from "@/utils/route";
import { getSessionStorage } from "@/utils/storage";
import { PHONE_VERIFICATION_REQUIRED_KEY } from "@/pages/user/phone-verification";
export var NeedsToVerifyPhoneReason;
(function (NeedsToVerifyPhoneReason) {
    NeedsToVerifyPhoneReason[NeedsToVerifyPhoneReason["Key"] = 0] = "Key";
    NeedsToVerifyPhoneReason[NeedsToVerifyPhoneReason["Role"] = 1] = "Role";
})(NeedsToVerifyPhoneReason || (NeedsToVerifyPhoneReason = {}));
export const useNeedsToVerifyPhone = ({ roles, phoneNumberConfirmed, skipPathnameCheck = false, }) => {
    const { pathname } = window.location;
    const route = getRouteByPath(pathname);
    // /user/phone-verification route is public but we want to know the reason why we the user is there
    if ((!skipPathnameCheck && route?.public) || pathname === "/") {
        return {
            needsToVerifyPhone: false,
            reason: null,
        };
    }
    const byRole = (roles || []).some(role => role.requires2FA) && !phoneNumberConfirmed;
    if (byRole) {
        return {
            needsToVerifyPhone: true,
            reason: NeedsToVerifyPhoneReason.Role,
        };
    }
    const byKey = getSessionStorage(PHONE_VERIFICATION_REQUIRED_KEY) === true;
    if (byKey) {
        return {
            needsToVerifyPhone: true,
            reason: NeedsToVerifyPhoneReason.Key,
        };
    }
    return {
        needsToVerifyPhone: false,
        reason: null,
    };
};
